<template>
  <div class="elite-tabs-wrapper-content">
    <log-list-table :filterSubject="signature" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "signature-view-logs",

  components: { LogListTable },

  props: ["signature"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
